import React, { useEffect, useState } from "react";
import ContactHeader from "../../components/contact/ContactHeader";
import { Box, Stack } from "@mui/material";
import InternalContact from "../../components/contact/InternalContact";
import ExternalContact from "../../components/contact/ExternalContact";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import HelperScreen from "../../common/ToolTip/HelperScreen";
import { handleCopyClick } from "../../utils/copytoClipboard";
import { showToastMsg } from "../../appStore/actions/global/action";
import useAppSelectors from "../../customHooks/useAppSelectors";
import { InviteType } from "../../utils/constant";
import { getInviteUrl } from "../../appStore/actions/subscriber/action";

const Contact = () => {
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const { accountLevelPeople, currentUserData } = useAppSelectors();
  const [showPromt, setShowPromt] = useState(true);
  const [internalInviteLink, setInternalInviteLink] = useState("");
  const [externalInviteLink, setExternalInviteLink] = useState("");
  const [isInviteLoading, setIsInviteLoading] = useState(false);

  const dispatch = useDispatch();

  const handleGetInviteLink = async (type) => {
    const res = await dispatch(getInviteUrl(type));
    const inviteMessage = res?.data?.inviteMessage;

    if (type === InviteType.internal) {
      setInternalInviteLink(inviteMessage);
    } else if (type === InviteType.external) {
      setExternalInviteLink(inviteMessage);
    }
  };

  const handleCopyInvite = (type) => {
    if (internalInviteLink || externalInviteLink) {
      if (type === InviteType?.external) {
        handleCopyClick(externalInviteLink, handleCopyClickCallback);
      } else if (type === InviteType?.internal) {
        handleCopyClick(internalInviteLink, handleCopyClickCallback);
      }
    } else {
      dispatch(showToastMsg(appContent?.KEY52));
    }
  };

  const handleCopyClickCallback = (type) => {
    if (type === "error") {
      dispatch(showToastMsg(appContent?.KEY52));
    } else {
      dispatch(showToastMsg(appContent?.KEY53));
    }
  };
  
  const fetchInviteLinks = async () => {
    setIsInviteLoading(true);
    await handleGetInviteLink(InviteType.internal);
    await handleGetInviteLink(InviteType.external);
    setIsInviteLoading(false);
  };

  useEffect(() => {
    fetchInviteLinks();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const contactTooltipSections = [
    {
      heading: appContent?.KEY15,
      content: [appContent?.KEY158],
    },
    {
      heading: appContent?.KEY16,
      content: [appContent?.KEY159],
    },
    {
      heading: appContent?.KEY160,
      content: [appContent?.KEY161],
    },
    {
      heading: appContent?.KEY162,
      content: [appContent?.KEY163],
    },
    {
      heading: appContent?.KEY164,
      content: [],
    },
  ];

  return (
    <div style={{ height: "calc(100vh - 4rem)", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      {!currentUserData?.tooltipContactsScreeenWeb && (
        <HelperScreen
          isContact={true}
          updateKey={"tooltip_contacts_screeen_web"}
          contactSections={contactTooltipSections}
        />
      )}
      <ContactHeader showPromt={showPromt} setShowPromt={setShowPromt} />
      <Box flex={1} overflow="hidden">
        <Stack direction="row" height="100%">
          <Box width={"50%"} borderRight={"1px solid black"} height="100%">
            <InternalContact
              currentUserData={currentUserData}
              accountLevelPeople={accountLevelPeople}
              handleCopyInvite={handleCopyInvite}
              showPromt={showPromt}
              isInviteLoading={isInviteLoading}
            />
          </Box>
          <Box width={"50%"} height="100%">
            <ExternalContact
              currentUserData={currentUserData}
              accountLevelPeople={accountLevelPeople}
              handleCopyInvite={handleCopyInvite}
              showPromt={showPromt}
              isInviteLoading={isInviteLoading}
            />
          </Box>
        </Stack>
      </Box>
    </div>
  );
};

export default Contact;
